import { PricingProps } from "components/common/pricing/Pricing"

export type PricingTitle = "Standard" | "Personnalisé" | "Starter 5" | "Starter 10" | "Premium"

export type PricingItemType = {
  id: string
  label: string
  status: "available" | "checkable" | "unavailable" | "none"
  value: number
  requested?: boolean
}

export enum PricingFormFieldNameEnum {
  PLAN = "plan",
  HAS_REDUCTION = "has_reduction",
  COLLABO_REDUCTION = "collabo_reduction",
  COLLABO_REDUCTION_START = "collabo_reduction_start",
  COLLABO_REDUCTION_END = "collabo_reduction_end",
  COLLABO_REDUCTION_TYPE = "collabo_reduction_type",
  MONTHLY_REDUCTION = "monthly_reduction",
  MONTHLY_REDUCTION_START = "monthly_reduction_start",
  MONTHLY_REDUCTION_END = "monthly_reduction_end",
  MONTHLY_REDUCTION_TYPE = "monthly_reduction_type",
  SUBSCRIPTION_REDUCTION = "subscription_reduction",
  SUBSCRIPTION_REDUCTION_START = "subscription_reduction_start",
  SUBSCRIPTION_REDUCTION_END = "subscription_reduction_end",
  SUBSCRIPTION_REDUCTION_TYPE = "subscription_reduction_type",
  PROVISION = "provision",
  BASE_AMOUNT = "base_amount",
  PER_USER = "per_user",
  MAX_USERS = "max_users",
  TOTAL = "total",
}

export type CollaboReductionType = {
  collabo_reduction?: number,
  collabo_reduction_start?: string,
  collabo_reduction_end?: string,
  collabo_reduction_type?: string,
}

export type SubscriptionReductionType = {
  subscription_reduction?: number,
  subscription_reduction_start?: string,
  subscription_reduction_end?: string,
  subscription_reduction_type?: string,
}

export type MonthlyReductionType = {
  monthly_reduction?: number,
  monthly_reduction_start?: string,
  monthly_reduction_end?: string,
  monthly_reduction_type?: string,
}

export type PricingFormType = CollaboReductionType & MonthlyReductionType & SubscriptionReductionType & {
  plan: string | null
  total?: number
  reductions: {}
  has_reduction: boolean
  provision: number | null
  base_amount?: number | null
  per_user?: number | null
  max_users?: number | null
}

export type PricingOptionsDummyDataType = Omit<PricingProps,
  "pricingOptions" | "value" | "items" | "handlePricingChoice">

export const CollaboReductionDefaultValues: CollaboReductionType = {
  collabo_reduction: undefined,
  collabo_reduction_start: undefined,
  collabo_reduction_end: undefined,
  collabo_reduction_type: undefined,
}

export const SubscriptionReductionDefaultValues: SubscriptionReductionType = {
  subscription_reduction: undefined,
  subscription_reduction_start: undefined,
  subscription_reduction_end: undefined,
  subscription_reduction_type: undefined,
}

export const MonthlyReductionDefaultValues: MonthlyReductionType = {
  monthly_reduction: undefined,
  monthly_reduction_start: undefined,
  monthly_reduction_end: undefined,
  monthly_reduction_type: undefined,
}

export const PricingFormDefaultValues: PricingFormType = {
  plan: "",
  total: 0,
  // chosen_options: [],
  reductions: {},
  has_reduction: false,
  provision: null,
  base_amount: null,
  per_user: null,
  max_users: null,
  ...CollaboReductionDefaultValues,
  ...SubscriptionReductionDefaultValues,
  ...MonthlyReductionDefaultValues,
}
